// Shared WAM v2 host bootstrap (used by both WAM effects and WAM instruments).
// The host SDK is bundled (self-hosted from our own origin) but lazy-loaded as
// its own chunk, so it only downloads on first WAM use and can't break if a CDN
// URL goes away (which is exactly what happened with the old pinned CDN import).
let hostGroupPromise: Promise<string> | null = null;

export async function ensureHost(ctx: AudioContext): Promise<string> {
  if (!hostGroupPromise) {
    hostGroupPromise = (async () => {
      const sdk: any = await import("@webaudiomodules/sdk");
      const [groupId] = await sdk.initializeWamHost(ctx);
      return groupId;
    })();
  }
  return hostGroupPromise;
}
